import { render } from "./Commitment.vue?vue&type=template&id=2210c452&scoped=true"
import script from "./Commitment.vue?vue&type=script&lang=js"
export * from "./Commitment.vue?vue&type=script&lang=js"

import "./Commitment.vue?vue&type=style&index=0&id=2210c452&lang=scss&scoped=true"

import exportComponent from "D:\\Wyspace\\WechatPlatForm_XINXIN\\WechatPlatForm\\Vue.EmployApply\\employVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2210c452"]])

export default __exports__